import { useContext, useEffect, useState } from "react";
import {
  getCategories,
  createCategories,
  updateCategories,
  deleteCategories,
  reactiveCategories,
} from "../services/console/categories";
import { AppContext } from "../context";

type UseType = "DATA" | "ACTIONS";
export type ActionType = "CREATE" | "UPDATE" | "DELETE" | "REACTIVE";

const handleCategoriesFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createCategories,
        fnMsg: t("Permissions.permissionsApiCreateLabel"),
      };
    case "UPDATE":
      return {
        actionFn: updateCategories,
        fnMsg: t("Permissions.permissionsApiUpdateLabel"),
      };
    case "DELETE":
      return {
        actionFn: deleteCategories,
        fnMsg: t("Permissions.permissionsApiDeleteLabel"),
      };
    case "REACTIVE":
        return {
          actionFn: reactiveCategories,
          fnMsg: t("Permissions.permissionsApiReactiveLabel"),
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const useCategories = (type: UseType) => {
  const { t, toast, setAppState } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  const categoriesAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleCategoriesFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg.replace('{name}', data?.name)}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA") {
      (async function () {
        await Promise.resolve(getCategories())
          .then((response) => {
            setData(response?.data);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [toast, reload, type]);

  return {
    data,
    categoriesAction,
    reloadFn,
  };
};
